module.exports = __webpack_public_path__ + "img/ep7-8.39fbee96.png";